<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { margin: 0; }

#app {
  font-family: var(--font-body), Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

:root { touch-action: pan-x pan-y; height: 100%; }
</style>
